import PicoWordpress from './PicoWordpress'
import PicoWrapper from './PicoWrapper'
import Scrapper from './Scrapper'
import JSONLD from './JSONLD'

const ContentDiscovery = (overrides) => {
    let content = {}

    if (PicoWordpress.isMatch()) {
        content = PicoWordpress.findContent(overrides)
    } else if (PicoWrapper.isMatch()) {
        content = PicoWrapper.findContent(overrides)
    } else if (JSONLD.isMatch()) {
        content = JSONLD.findContent(overrides)
    } else if (Scrapper.isMatch()) {
        content = Scrapper.findContent(overrides)
    }
    return content
}

export default ContentDiscovery
